/**
 * Calendar-day comparison helpers in the viewer's local timezone.
 */

import { pad } from './_pad.js';

/**
 * `true` when two dates fall on the same local-time calendar day.
 * @param {Date} a
 * @param {Date} b
 * @returns {boolean}
 */
export const datesAreSame = (a, b) =>
  a.getFullYear() === b.getFullYear() &&
  a.getMonth() === b.getMonth() &&
  a.getDate() === b.getDate();

/**
 * Sortable `"YYYY-MM-DD"` key in the viewer's local timezone. Accepts an
 * ISO string or a `Date`. Use this for any "what calendar day is this?"
 * grouping or comparison.
 *
 * @param {string | Date} input
 * @returns {string}
 */
export const getLocalDateKey = (input) => {
  const d = input instanceof Date ? input : new Date(input);
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
};

/** Today's local-day key (`"YYYY-MM-DD"`). */
export const todayKey = () => getLocalDateKey(new Date());

/** `true` when `iso` falls on a calendar day strictly before today (local). */
export const isPastDay = (iso) => getLocalDateKey(iso) < todayKey();
